module.exports = __webpack_public_path__ + "static/media/physiowerk-logo-mobile-white.2cd17b0c.svg";